import { motion } from "framer-motion";
import { CheckCircle, Star, Wrench, Shield, Clock } from "lucide-react";

const HeroSection = () => {
  const container = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.12 } },
  };

  const item = {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
  };

  const badges = [
    { icon: Shield, label: "Genuine Parts" },
    { icon: Wrench, label: "Expert Mechanics" },
    { icon: Clock, label: "Same-Day Service" },
  ];

  return (
    <motion.div variants={container} initial="hidden" animate="show" className="py-4 sm:py-8 lg:py-0">

      {/* Location badge */}
      <motion.div variants={item} className="mb-6">
        <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF6B35]/10 border border-[#FF6B35]/20 rounded-full text-[#FF6B35] text-xs font-semibold">
          <span className="w-1.5 h-1.5 bg-[#FF6B35] rounded-full animate-pulse" />
          Pune • Doorstep Service Available
        </span>
      </motion.div>

      {/* Main heading */}
      <motion.h1 variants={item}
        className="text-4xl sm:text-5xl lg:text-6xl font-black text-gray-900 leading-[1.05] mb-6 tracking-tight">
        Your Bike Deserves<br />
        <span className="text-[#FF6B35]">Premium Care</span>
      </motion.h1>

      {/* Description */}
      <motion.p variants={item} className="text-base sm:text-lg text-gray-500 max-w-md mb-8 leading-relaxed">
        Expert repairs & maintenance with genuine parts. We come to you — free pickup & delivery across Pune.
      </motion.p>

      {/* Trust badges */}
      <motion.div variants={item} className="flex flex-wrap gap-3 mb-8">
        {badges.map(({ icon: Icon, label }) => (
          <div key={label} className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-200 rounded-xl shadow-sm">
            <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0" />
            <span className="text-xs sm:text-sm font-semibold text-gray-700">{label}</span>
          </div>
        ))}
      </motion.div>

      {/* Social proof */}
      <motion.div variants={item} className="flex items-center gap-4">
        <div className="flex -space-x-2">
          {["RK", "AP", "SM", "NP"].map((initials, i) => (
            <div key={i}
              className="w-8 h-8 rounded-full border-2 border-white flex items-center justify-center text-[10px] font-bold text-white shadow-sm"
              style={{ backgroundColor: ["#FF6B35", "#1C1C1C", "#FF8C5A", "#333"][i] }}>
              {initials}
            </div>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" />
            ))}
          </div>
          <span className="text-sm font-bold text-gray-900">4.9</span>
          <span className="text-sm text-gray-500">• 5,000+ happy riders</span>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default HeroSection;
